import { useQuery } from '@tanstack/react-query';
import { useBasket } from '~/features/basket';

type Props = {
    id: string;
    onSuccess?: () => void;
};

const useShipmentMethods = ({ id, onSuccess }: Props) => {
    const { getShippingMethods } = useBasket();

    return useQuery({
        queryKey: ['carriers', id],
        queryFn: async () => {
            try {
                const response = await getShippingMethods(id);
                onSuccess?.();
                return response;
            } catch (error) {
                console.warn('error', error);
            }
        },
        staleTime: 5 * 1000, // 5 seconds
        enabled: !!id,
    });
};

export default useShipmentMethods;
